import script from "./smallClass.vue?vue&type=script&setup=true&lang=js"
export * from "./smallClass.vue?vue&type=script&setup=true&lang=js"

import "./smallClass.vue?vue&type=style&index=0&id=c8820ab6&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8820ab6"]])

export default __exports__